import { HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

import { SseHttpError } from '../api/sse-client';
import { AuthService } from './auth.service';

function isHttp401(err: unknown): boolean {
  if (err instanceof HttpErrorResponse) return err.status === 401;
  if (err instanceof SseHttpError) return err.status === 401;
  return false;
}

/**
 * Wraps a request factory with automatic 401 retry via auth token refresh.
 * Works for both HttpClient Observables and SSE fetch-based Observables.
 */
export function withAuthRetry<T>(
  auth: AuthService,
  request: () => Observable<T>,
  isAuthError: (err: unknown) => boolean = isHttp401,
): Observable<T> {
  return request().pipe(
    catchError((err) => {
      if (!isAuthError(err)) return throwError(() => err);
      return auth.refreshIfNeeded('401').pipe(switchMap(() => request()));
    }),
  );
}
